var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRateReviewStar4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 47,
    viewBox: "0 0 49 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4906 39.1198C24.9206 38.8199 24.2396 38.8196 23.6694 39.1189L13.1189 44.6573C11.6826 45.4112 10.0052 44.1914 10.2799 42.5927L12.2939 30.8704C12.4032 30.2342 12.1918 29.5851 11.729 29.1352L3.19154 20.8379C2.02674 19.7058 2.66793 17.7295 4.27546 17.4969L16.059 15.7918C16.6966 15.6995 17.2479 15.2994 17.5334 14.7219L22.8085 4.05006C23.5269 2.59664 25.5996 2.59664 26.318 4.05006L31.5931 14.7219C31.8785 15.2994 32.4299 15.6995 33.0675 15.7918L44.851 17.4969C46.4586 17.7295 47.0998 19.7058 45.935 20.8379L37.3975 29.1352C36.9346 29.5851 36.7233 30.2342 36.8326 30.8704L38.8458 42.5881C39.1206 44.1876 37.4415 45.4075 36.0052 44.6518L25.4906 39.1198Z",
    fill: "#354D9E",
    stroke: "#354D9E",
    strokeWidth: 0.734043,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1298 27.2756V28.2778H26.9375V31.1592H25.81V28.2778H19.6244V27.4635L25.4341 20.1975H26.6869L21.0808 27.2756H25.8413V24.7388H26.9375V27.2756H29.1298Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRateReviewStar4);
export default __webpack_public_path__ + "static/media/IconRateReviewStar-4.feb3417874b8b3e5c0fc1a0e04ae06ed.svg";
export { ForwardRef as ReactComponent };